import { baseTheme } from "./base";
const overrideColors = {
    teal: "#1E818A",
    ocean: "#0A636B",
    rainForest: "#0E4B53",
};
const colors = Object.assign(Object.assign(Object.assign({}, baseTheme.colors), overrideColors), { cl17: overrideColors.teal, cl18: overrideColors.ocean, cl19: overrideColors.rainForest });
colors.primaryLight = colors.cl17;
colors.primary = colors.cl18;
colors.primaryDark = colors.cl19;
export const koloTheme = Object.assign(Object.assign({}, baseTheme), { colors: Object.assign({}, colors) });
